import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { NotificationContainer } from './components/common/NotificationContainer';
import { DevPanel } from './components/common/DevPanel';
import { HomePage, PricingPage, TermsPage, PrivacyPage, RefundsPage } from './pages';
import { TestPaymentPage } from './components/payment/TestPaymentPage';
import { useTimeWheelStore } from './store';
import './styles/globals.css';
import { StickyUpgradeCTA } from './components/payment/StickyUpgradeCTA';

function App() {
  const { updateCurrentTime } = useTimeWheelStore();

  useEffect(() => {
    updateCurrentTime();
  }, [updateCurrentTime]);

  // 移除运行时 defuse 逻辑，避免个别环境异常；改为结构与样式层面保证可点击

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-900 flex flex-col">
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/test-payment" element={<TestPaymentPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/refunds" element={<RefundsPage />} />
        </Routes>
      </main>
      <Footer />
      <NotificationContainer />
      {import.meta.env.PROD ? null : <DevPanel />}
      {import.meta.env.PROD ? <StickyUpgradeCTA /> : null}
    </div>
  );
}

export default App;
